import { AbstractControl } from '@angular/forms';

export function requiredAndTrueValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (value !== true) {
        return { 'requiredAndTrue': true };
    }
    return null;
}
